module.exports = __webpack_public_path__ + "img/IMG_4451.6106dc27.jpg";